import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { BUSINESS } from "../../lib/site";

const links = [
  { label: "Services", href: "#services" },
  { label: "Ethos", href: "#ethos" },
  { label: "Gallery", href: "#gallery" },
  { label: "Shop", href: "#shop" },
  { label: "Visit", href: "#visit" },
];

export const Header = ({ onBook }) => {
  const [open, setOpen] = useState(false);

  const go = (href) => {
    setOpen(false);
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
      className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-black/70 border-b border-white/10"
      data-testid="site-header"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <button onClick={() => go("#top")} className="flex items-center gap-3 group" data-testid="logo-btn">
          <img src={BUSINESS.logo} alt="El Japonais" className="h-11 w-11 rounded-full object-cover ring-1 ring-[#C9A24B]/50" />
          <span className="font-serif-display text-xl tracking-wide gold-gradient-text hidden sm:block">El Japonais</span>
        </button>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <button
              key={l.href}
              onClick={() => go(l.href)}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className="text-xs uppercase tracking-[0.2em] text-[#8A8A8A] hover:text-[#FAFAFA] transition-colors duration-300 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[#C9A24B] rounded"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            onClick={onBook}
            data-testid="header-book-btn"
            className="hidden sm:inline-flex items-center px-6 py-3 text-xs uppercase tracking-[0.2em] bg-[#C9A24B] text-black font-semibold rounded-sm hover:scale-105 hover:bg-[#d9b463] transition-transform transition-colors duration-300 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-white"
          >
            Book Now
          </button>
          <button className="md:hidden text-[#FAFAFA]" onClick={() => setOpen(!open)} data-testid="mobile-menu-btn" aria-label="Menu">
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="md:hidden overflow-hidden bg-black/95 border-t border-white/10"
          >
            <div className="px-6 py-6 flex flex-col gap-5">
              {links.map((l) => (
                <button key={l.href} onClick={() => go(l.href)} className="text-left text-sm uppercase tracking-[0.2em] text-[#8A8A8A]" data-testid={`mobile-nav-${l.label.toLowerCase()}`}>
                  {l.label}
                </button>
              ))}
              <button onClick={() => { setOpen(false); onBook(); }} className="mt-2 px-6 py-3 text-xs uppercase tracking-[0.2em] bg-[#C9A24B] text-black font-semibold rounded-sm" data-testid="mobile-book-btn">
                Book Now
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
